import React from "react";
import useTranslationDashboard from "../useTranslationDashboard.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import useMutationRecruiterAlertUpdate from "../mutate/useMutationRecruiterAlertUpdate.js";
import Alert from "@mui/material/Alert";
import "./DashboardAlertsListItems.scss";
import useErrorModal from "../../common/modals/useErrorModal.js";
import useServerErrorFormatter from "../../common/modals/useServerErrorFormatter.js";
import TypeUtils from "../../../utils/TypeUtils.js";

export default function DashboardAlertsListItems(props) {
  const { items: alerts } = props;

  const {
    mutate,
    loading,
    errors: errorsUpdateErrors,
  } = useMutationRecruiterAlertUpdate();

  const { t, loading: tLoading } = useTranslationDashboard();
  useShowLoader(tLoading || loading, "DashboardAlertsListItems");

  const errorMsg = useServerErrorFormatter(errorsUpdateErrors);

  const { ErrorModal, show: showErrorModal } = useErrorModal(
    <>
      <p>{t("dashboard:recruiters_dashboard_alerts_update_error")}</p>
      {errorMsg}
    </>
  );

  const emptyMsg = t("dashboard:recruiters_dashboard_empty_alerts_list_msg");

  const onClose = (id) => {
    const variables = {};
    variables["id"] = id;
    variables["status"] = "VIEWED";
    mutate({ variables }).catch((/*error*/) => {
      showErrorModal();
    });
  };

  return (
    <>
      {ErrorModal}
      <div className="DashboardAlertsListItems spaced-children">
        {TypeUtils.arrayIsEmpty(alerts) && (
          <span className={"empty-message"}>{emptyMsg}</span>
        )}
        {alerts.map((alert, i) => (
          <Alert
            key={i}
            className="alert-col"
            variant="filled"
            severity={alert.alertType.toLowerCase()}
            onClose={() => {
              onClose(alert._id);
            }}
          >
            {alert.message}
          </Alert>
        ))}
      </div>
    </>
  );
}
